export default "__VITE_ASSET__gM26pYqK__"